import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-g01-content-button-list" }
const _hoisted_2 = ["id", "onClick"]
const _hoisted_3 = {
  key: 0,
  class: "p-g01-content-button-list__item__label"
}
const _hoisted_4 = {
  key: 1,
  class: "p-g01-content-button-list__item__label p-g01-content-button-list__item__label--point"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconItemCategory = _resolveComponent("IconItemCategory")!
  const _component_IconPoint = _resolveComponent("IconPoint")!
  const _component_IconArrowBottom = _resolveComponent("IconArrowBottom")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _directive_scroll_to = _resolveDirective("scroll-to")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, key) => {
      return (_openBlock(), _createElementBlock("li", {
        key: key,
        class: "p-g01-content-button-list__item"
      }, [
        _withDirectives((_openBlock(), _createElementBlock("a", {
          href: "#",
          id: 'btn_' + category.category_id,
          onClick: ($event: any) => (_ctx.onClick($event, category.category_id)),
          class: _normalizeClass(["p-g01-content-button-list__item__link", { inactive: category.sku_set.length == 0 }])
        }, [
          _createElementVNode("template", null, [
            (_ctx.isCategory)
              ? (_openBlock(), _createBlock(_component_IconItemCategory, {
                  key: 0,
                  id: category.category_id,
                  class: "p-g01-content-button-list__item__icon"
                }, null, 8, ["id"]))
              : (_openBlock(), _createBlock(_component_IconPoint, {
                  key: 1,
                  "icon-size": 24,
                  class: "p-g01-content-button-list__item__icon"
                }))
          ]),
          (_ctx.isCategory)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(category.category_name), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(category.category_name), 1)),
          _createVNode(_component_IconBase, {
            "view-box": "0 0 24 24",
            width: "24",
            height: "24",
            color: "#b6b6b6",
            class: "p-g01-content-button-list__item__arrow"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconArrowBottom)
            ]),
            _: 1
          })
        ], 10, _hoisted_2)), [
          [_directive_scroll_to, `#ex-${category.category_id}`]
        ])
      ]))
    }), 128))
  ]))
}